const MenuItems = [
  {
    id: 0,
    title: 'HOME',
    cName: 'nav-links',
    url: '#HomePage',
  },

  {
    id: 1,
    title: 'INVITATION',
    cName: 'nav-links',
    url: '#InvitationPage',
  },
  {
    id: 2,
    title: 'WEDDING',
    cName: 'nav-links',
    url: '#wedding-ceremony',
  },
  {
    id: 3,
    title: 'FAMILY',
    cName: 'nav-links',
    url: '#Gallery-container',
  },
  {
    id: 4,
    title: 'WEDDING VIDEO',
    cName: 'nav-links',
    url: '#video-container',
  },
]

export default MenuItems
